import { Suspense } from 'react';
import { createRoot } from 'react-dom/client';

import { Base } from './Base';

import { CircularProgress, Stack } from '@mui/material';
import './i18n';
import './index.css';

const container = document.getElementById('root') as Element;
const root = createRoot(container);

root.render(
  <Suspense
    fallback={
      <Stack
        sx={{
          alignItems: 'center',
          justifyContent: 'center',
          height: '100vh'
        }}>
        <CircularProgress style={{ color: 'var(--color-primary-red-100)' }}></CircularProgress>
      </Stack>
    }
  >
    <Base />
  </Suspense>
);
